/**
 * ファイルをリクエストボディに直接載せて送信する（multipart/form-dataを使わない）
 * サーバー側は raw.file ミドルウェアで通常のアップロードファイルとして受け取る
 *
 * @param {string} url 送信先
 * @param {File} file 送信するファイル
 * @param {Object} headers 追加のリクエストヘッダー
 * @returns {Promise}
 */
export const uploadFile = (url, file, headers = {}) => {
  return axios({
    method: 'POST',
    url: url,
    headers: Object.assign({}, headers, {
      'Content-Type': file.type || 'application/octet-stream',
      'X-File-Name': encodeURIComponent(file.name)
    }),
    data: file
  })
}

/**
 * el-upload の http-request 用
 * 成功時はレスポンスボディ、失敗時は el-upload 標準と同じ形（status, message=レスポンス文字列）のエラーを返す
 *
 * @param {Object} option el-upload から渡されるオプション
 * @returns {Promise}
 */
export const elUploadRequest = (option) => {
  return uploadFile(option.action, option.file, option.headers).then(
    (response) => response.data,
    (error) => {
      const response = error.response || {}
      const err = new Error(
        typeof response.data === 'string' ? response.data : JSON.stringify(response.data || {})
      )
      err.status = response.status
      throw err
    }
  )
}
